import { IconSize } from '../../Icon'
import { InputSize } from '../types/size'

const inputSizeToIconSize: Record<InputSize, IconSize> = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
}

export const getIconSize = (inputSize: InputSize = 'sm'): IconSize => inputSizeToIconSize[inputSize]
